import { useEffect } from 'react';
import useAPI from 'hooks/useAPI';
import useGlobalLoading from 'hooks/useGlobalLoading';
import { useHistory } from 'react-router-dom';

/**
 * 
 * @param {Object} props 'setRows' is the state setting function used to set the rows for the customers with the api's response
 * @returns 'viewCustomer', a function that redirects the user to the customer's information page,
 *  and 'search', the function that updates the criteria and requests a new batch of customers fitting that criteria.
 */

function useCustomers({ setRows, setTotalCustomers }) {
  console.log("useCustomers hook initialized");
  const api = useAPI();
  const { setIsLoading } = useGlobalLoading();
  const history = useHistory();
  const viewCustomer = enrollmentNumber => {
    history.push(`/customers/${enrollmentNumber}`)
  }

  const search = (data, page, rowsPerPage) => {
    setIsLoading(true);
    if (data.enrollmentNumber) {
      const utilityAccountId = localStorage.getItem('accountId');

      if(!utilityAccountId) {
        alert('please add and select a utility account before searching via enrollment number');
        return;
      }

      api
        .get(`/heat/${utilityAccountId}/enrollment/${data.enrollmentNumber}`)
        .then(res =>{
          setRows([res.data.customer])
          if (setTotalCustomers) setTotalCustomers(res.data.total);
        })
        .catch(err => console.log(err))
        .finally(() => setIsLoading(false));
    }
    else {
      const criteria = Object
        .entries(data)
        .reduce((accumulator, [key, value]) => {
          if (value && value.length) {
            accumulator[key] = value;
          }

          return accumulator;
        }, {});
      criteria.page = page; 
      criteria.limit = rowsPerPage; 
      sessionStorage.setItem('criteria', JSON.stringify(criteria));

      api
        .get('/customers', {
          params: criteria
        })
        .then(res => {
          setRows(res.data.customers)
          if (setTotalCustomers) setTotalCustomers(res.data.total);
        })
        .catch(err => console.log(err.message))
        .finally(() => setIsLoading(false));
    }
  }

  return { viewCustomer, search };
}

export default useCustomers;